// Esquema de contenidos editable desde el panel admin.
// Cada campo: { key, label, type } — type: text | textarea | image | bool | list_string | list_grouped
export const CONTENT_SCHEMA = [
  {
    id: "marca",
    label: "Marca y logo",
    fields: [
      { key: "site.name", label: "Nombre del sitio", type: "text" },
      { key: "site.tagline", label: "Lema / tagline", type: "text" },
      { key: "site.logo_url", label: "Logotipo (imagen)", type: "image" },
    ],
  },
  {
    id: "banner",
    label: "Aviso / Banner superior",
    fields: [
      { key: "banner.enabled", label: "Mostrar aviso", type: "bool" },
      { key: "banner.text", label: "Texto del aviso", type: "text" },
      { key: "banner.link", label: "Enlace (opcional)", type: "text" },
      { key: "banner.link_text", label: "Texto del enlace", type: "text" },
    ],
  },
  {
    id: "nav",
    label: "Menú de navegación",
    fields: [
      { key: "nav.items", label: "Elementos del menú", type: "list_grouped", fields: [{ key: "label", label: "Etiqueta", type: "text" }, { key: "link", label: "Enlace", type: "text" }] },
      { key: "nav.cta_text", label: "Botón 'Crear cuenta' — texto", type: "text" },
      { key: "nav.cta_link", label: "Botón 'Crear cuenta' — enlace", type: "text" },
    ],
  },
  {
    id: "hero",
    label: "Portada (Hero)",
    fields: [
      { key: "hero.badge", label: "Insignia superior", type: "text" },
      { key: "hero.title_line1", label: "Título — línea 1", type: "text" },
      { key: "hero.title_line2", label: "Título — línea 2 (palabra dorada al final)", type: "text" },
      { key: "hero.title_line3", label: "Título — línea 3", type: "text" },
      { key: "hero.subtitle", label: "Subtítulo", type: "textarea" },
      { key: "hero.cta1_text", label: "Botón 1 — texto", type: "text" },
      { key: "hero.cta1_link", label: "Botón 1 — enlace", type: "text" },
      { key: "hero.cta2_text", label: "Botón 2 — texto", type: "text" },
      { key: "hero.cta2_link", label: "Botón 2 — enlace", type: "text" },
      { key: "hero.image_url", label: "Imagen principal", type: "image" },
      { key: "hero.tag_title", label: "Tarjeta flotante — título", type: "text" },
      { key: "hero.tag_text", label: "Tarjeta flotante — texto", type: "text" },
      { key: "hero.stats", label: "Estadísticas", type: "list_grouped", fields: [{ key: "n", label: "Cifra", type: "text" }, { key: "label", label: "Descripción", type: "text" }] },
    ],
  },
  {
    id: "bento",
    label: "Categorías (portada)",
    fields: [
      { key: "bento.eyebrow", label: "Etiqueta pequeña", type: "text" },
      { key: "bento.title", label: "Título de la sección", type: "text" },
      { key: "bento.link_text", label: "Texto del enlace 'ver todo'", type: "text" },
      { key: "bento.items", label: "Tarjetas de categorías", type: "list_grouped", fields: [{ key: "title", label: "Título", type: "text" }, { key: "desc", label: "Descripción", type: "text" }, { key: "image_url", label: "Imagen", type: "image" }, { key: "link", label: "Enlace", type: "text" }] },
    ],
  },
  {
    id: "featured",
    label: "Destacados y marquee",
    fields: [
      { key: "marquee.items", label: "Marquee (frases)", type: "list_string" },
      { key: "featured.eyebrow", label: "Etiqueta pequeña", type: "text" },
      { key: "featured.title", label: "Título de la sección", type: "text" },
    ],
  },
  {
    id: "about",
    label: "Sobre nosotros",
    fields: [
      { key: "about.eyebrow", label: "Etiqueta pequeña", type: "text" },
      { key: "about.title", label: "Título (palabra final dorada)", type: "text" },
      { key: "about.mission_title", label: "Misión — título", type: "text" },
      { key: "about.mission_text", label: "Misión — texto", type: "textarea" },
      { key: "about.vision_title", label: "Visión — título", type: "text" },
      { key: "about.vision_text", label: "Visión — texto", type: "textarea" },
      { key: "about.values", label: "Valores", type: "list_string" },
      { key: "about.team", label: "Equipo de psicólogas", type: "list_grouped", fields: [{ key: "name", label: "Nombre", type: "text" }, { key: "role", label: "Rol", type: "text" }, { key: "photo", label: "Foto", type: "image" }, { key: "bio", label: "Semblanza", type: "textarea" }, { key: "trajectory", label: "Trayectoria", type: "textarea" }] },
    ],
  },
  {
    id: "trust",
    label: "Confianza y FAQ",
    fields: [
      { key: "trust.items", label: "Tarjetas de confianza", type: "list_grouped", fields: [{ key: "title", label: "Título", type: "text" }, { key: "desc", label: "Descripción", type: "textarea" }] },
      { key: "faq.eyebrow", label: "FAQ — etiqueta pequeña", type: "text" },
      { key: "faq.title", label: "FAQ — título", type: "text" },
      { key: "faq.items", label: "Preguntas frecuentes", type: "list_grouped", fields: [{ key: "q", label: "Pregunta", type: "text" }, { key: "a", label: "Respuesta", type: "textarea" }] },
    ],
  },
  {
    id: "footer",
    label: "Pie de página",
    fields: [
      { key: "footer.about_text", label: "Texto de presentación", type: "textarea" },
      { key: "footer.explore_title", label: "Título columna 'Explora'", type: "text" },
      { key: "footer.links", label: "Enlaces del pie", type: "list_grouped", fields: [{ key: "label", label: "Etiqueta", type: "text" }, { key: "link", label: "Enlace", type: "text" }] },
      { key: "footer.note", label: "Nota de confianza", type: "textarea" },
      { key: "footer.email", label: "Correo visible", type: "text" },
      { key: "footer.copyright", label: "Copyright", type: "text" },
    ],
  },
  {
    id: "contacto",
    label: "Contacto y redes",
    fields: [
      { key: "contact.whatsapp", label: "WhatsApp", type: "text" },
      { key: "contact.email", label: "Correo de contacto", type: "text" },
      { key: "contact.address", label: "Dirección / sede", type: "text" },
      { key: "contact.hours", label: "Horarios (uno por línea)", type: "textarea" },
      { key: "social.instagram", label: "Instagram (URL)", type: "text" },
      { key: "social.facebook", label: "Facebook (URL)", type: "text" },
      { key: "social.tiktok", label: "TikTok (URL)", type: "text" },
    ],
  },
  {
    id: "mensajes",
    label: "Mensajes y estados",
    fields: [
      { key: "msgs.cart_empty_title", label: "Carrito vacío — título", type: "text" },
      { key: "msgs.cart_empty_text", label: "Carrito vacío — texto", type: "textarea" },
      { key: "msgs.catalog_empty_title", label: "Catálogo sin resultados — título", type: "text" },
      { key: "msgs.catalog_empty_text", label: "Catálogo sin resultados — texto", type: "textarea" },
      { key: "msgs.checkout_gate_title", label: "Checkout sin sesión — título", type: "text" },
      { key: "msgs.checkout_gate_text", label: "Checkout sin sesión — texto", type: "textarea" },
    ],
  },
  {
    id: "legal",
    label: "Textos legales",
    fields: [
      { key: "legal.privacy_title", label: "Privacidad — título", type: "text" },
      { key: "legal.privacy", label: "Política de privacidad", type: "textarea" },
      { key: "legal.terms_title", label: "Términos — título", type: "text" },
      { key: "legal.terms", label: "Términos y condiciones", type: "textarea" },
    ],
  },
];
